/// <amd-module name="SearchUI/Helpers/WikiHelper" />

import { WikiResult } from "SearchUI/Contracts/Search.SharedLegacy";
import * as Constants from "SearchUI/Constants";

export namespace UrlEscapeConstants {
    export const HyphenRegExp = /-/g;
    export const SpaceRegExp = /\ /g;
    export const OpeningBracesRegExp = /\(/g;
    export const ClosingBracesRegExp = /\)/g;
    export const OpeningBracesEncoding = "\\(";
    export const ClosingBracesEncoding = "\\)";
    export const SpaceEncoding = "%20";
    export const HyphenEncoding = "%2D";
    export const EscapedHyphenEncoding = "%252D";
    export const HyphenEncodingRegExp = /%2D/g;
    export const EscapedHyphenEncodingRegExp = /%252D/g;
}

export function getWikiPagePathFromGitPath(gitPath: string) {
    if (!gitPath) {
        return null;
    }

    gitPath = gitPath.replace(/-/g, Constants.PathConstants.WhiteSpace);

    for (let i = 0; i < Constants.WikiGitIllegalSpecialCharEcapes.length; i++) {
        gitPath = gitPath.replace(Constants.WikiGitIllegalSpecialCharEcapes[i],
            Constants.WikiGitIllegalSpecialChars[i]);
    }
    return gitPath;
}

export function removeExtensionfromPagePath(path: string): string {
    const extensionStart = path.lastIndexOf(".");

    return Constants.FormatConstants.MDFormat.toLocaleUpperCase().localeCompare(path.substring(extensionStart).toLocaleUpperCase(), navigator.language) === 0
        ? path.substring(0, extensionStart)
        : path;
}

/**
* Constructs file contents url for project wikis, which takes the user into wiki hub
*/
export function constructLinkToProjectWikiContent(result: WikiResult, wikiUrl: string, wikiPath: string): string {
    let resultantURLToWikiHubContent: string;

    resultantURLToWikiHubContent = wikiUrl
        + encodeURIComponent(result.project)
        + Constants.RepoConstants.PathSeparator
        + Constants.PathConstants.Underscore
        + encodeURIComponent(Constants.WikiControllerName)
        + Constants.PathConstants.QuestionMark
        + encodeURIComponent(Constants.WikiUrlParameters.PagePath)
        + Constants.PathConstants.Equal
        // '-' in the page path relates to escaped '%2D' in URL.
        + encodeURIComponent(wikiPath.split("\\").join("/").replace(UrlEscapeConstants.HyphenRegExp, UrlEscapeConstants.HyphenEncoding));

    return resultantURLToWikiHubContent;
}

/**
* Constructs file contents url for project and code wikis, which takes the user into wiki hub
*/
export function constructLinkToWikiContent(result: WikiResult, wikiUrl: string, wikiFilePath: string): string {
    let resultantURLToWikiHubContent: string;

    let mappedPath = result.mappedPath ? result.mappedPath.split("\\").join("/") : "";
    if (!(mappedPath.length > 0 && mappedPath.charAt(mappedPath.length - 1) == "/")) {
        mappedPath = mappedPath.concat("/");
    }

    let wikiName = result.wiki;
    if (!wikiName) {
        // For back compat use repo name instead of wiki name as for project wikis it is same.
        // This can be removed after Search upgrade to M130 and after wiki Mappings have been updated for M130 changes. 
        wikiName = result.repository;
    }

    resultantURLToWikiHubContent = wikiUrl
        + encodeURIComponent(result.project)
        + Constants.RepoConstants.PathSeparator
        + Constants.PathConstants.Underscore
        + encodeURIComponent(Constants.WikiControllerName)
        + Constants.RepoConstants.PathSeparator
        + encodeURIComponent(Constants.WikiResourceName)
        + Constants.RepoConstants.PathSeparator
        + encodeURIComponent(wikiName)
        + Constants.PathConstants.QuestionMark
        + encodeURIComponent(Constants.WikiUrlParameters.PagePath)
        + Constants.PathConstants.Equal
        // '-' in the page path relates to escaped '%2D' in URL.
        + encodeURIComponent(getWikiPagePathFromGitPath(wikiFilePath.split("\\").join("/").substring(mappedPath.length - 1)).replace(UrlEscapeConstants.HyphenRegExp, UrlEscapeConstants.HyphenEncoding));

    if (result.wikiVersion) {
        resultantURLToWikiHubContent = resultantURLToWikiHubContent
            + Constants.PathConstants.Ampersand
            + encodeURIComponent(Constants.WikiUrlParameters.WikiVersion)
            + Constants.PathConstants.Equal
            + encodeURIComponent("GB" + result.wikiVersion);
    }

    return resultantURLToWikiHubContent;
}
